import get from 'lodash/get';
import pick from 'lodash/pick';

import canShowInstallAppDialog from '../../common/actions/utils/dialog/canShowInstallAppDialog';
import registrationViews from '../../common/constants/dialogs/registrationViews';
import {
  CLOSE_DOWNLOAD_APP_DIALOG,
  closeNowPlayingDialog,
  OPEN_DOWNLOAD_APP_DIALOG,
  OPEN_INTEREST_SELECTOR_DIALOG,
  openDownloadAppDialogAndTrack,
  openNowPlayingDialog,
} from '../../common/actions/dialog';
import {
  AUTHENTICATION_SUCCESSFUL,
  openUserRegistrationDialogWithAuthViewAttribute,
} from '../../common/actions/auth';
import { PLAY_PREROLL } from '../../common/actions/preroll';
import { PLAY } from '../../common/actions/player';
import { selectIsUserSubscribed } from '../../common/selectors/me';
import viewTypes from '../../common/constants/auth/viewTypes';

const validActions = [
  PLAY,
  PLAY_PREROLL,
  AUTHENTICATION_SUCCESSFUL,
  OPEN_DOWNLOAD_APP_DIALOG,
  CLOSE_DOWNLOAD_APP_DIALOG,
  OPEN_INTEREST_SELECTOR_DIALOG,
];

export default ({ getState, dispatch }) =>
  (next) =>
  (action) => {
    const { type } = action;

    if (!validActions.includes(type)) {
      next(action);
      return;
    }

    const state = getState();
    const {
      dialog: { isNowPlayingDialogOpen },
    } = state;
    const { source, viewTypeData } = get(action, 'meta', {});
    const { viewType, attribute } = pick(viewTypeData, [
      'viewType',
      'attribute',
    ]);

    switch (type) {
      case PLAY_PREROLL:
        dispatch(openNowPlayingDialog());
        next(action);
        break;
      case PLAY:
        if (!isNowPlayingDialogOpen && canShowInstallAppDialog(state)) {
          dispatch(openDownloadAppDialogAndTrack());
        } else {
          dispatch(openNowPlayingDialog());
        }
        next(action);
        break;
      case OPEN_DOWNLOAD_APP_DIALOG:
      case OPEN_INTEREST_SELECTOR_DIALOG:
        if (isNowPlayingDialogOpen) {
          dispatch(closeNowPlayingDialog());
        }
        next(action);
        break;
      case CLOSE_DOWNLOAD_APP_DIALOG:
        // Need to wait for any state updates that are triggered by the dialog closing
        // to complete before opening the next NowPlayingDialog. See mint reducer for
        // example of the use case.
        next(action);
        dispatch(openNowPlayingDialog());
        break;
      case AUTHENTICATION_SUCCESSFUL:
        next(action);

        if (selectIsUserSubscribed(getState())) {
          dispatch(
            openUserRegistrationDialogWithAuthViewAttribute(
              attribute,
              registrationViews.linkWithAlexa,
            ),
          );
          return;
        }
        // If there is a source value here, that means the user is within the sub
        // flow itself and has seen an upsell. In this case, we don't want to show
        // the dialog.
        if (viewType === viewTypes.signUp && !source) {
          dispatch(
            openUserRegistrationDialogWithAuthViewAttribute(
              attribute,
              registrationViews.goPremium,
            ),
          );
        }
        break;
      default:
        next(action);
    }
  };
